import { extendObservable } from "mobx";
import { ObjectUtils } from "../../utils/ObjectUtils";
import { AlertaDto } from "../dto/AlertaDto";
import { OrgaoJulgadorCargo } from "../dto/OrgaoJulgadorCargo";
import { ClasseJudicial } from "./ClasseJudicial";
import { Indicador } from "./Indicador";
import { OrgaoJulgador } from "./OrgaoJulgador";
import { Partes } from "./Partes";
import { Relator } from "./Relator";
import { TarefasFluxo } from "./TarefasFluxo";
import { IAssunto } from "../Assunto";

export class DadosProcesso {

    static mobxInicial = () => ({
        partes: undefined,
        mensagemErroPartes: undefined
    })

    static novo(partial: Partial<DadosProcesso>): DadosProcesso {
        const dadosProcesso = new DadosProcesso();

        const mobxInicial = DadosProcesso.mobxInicial();
        extendObservable(dadosProcesso, mobxInicial);

        return ObjectUtils.assign(dadosProcesso, partial);
    }

    idProcesso: number = undefined;
    numero: string = undefined;
    classeJudicial: ClasseJudicial = undefined;
    classesJudicial: ClasseJudicial[] = [];
    relator: Relator = undefined;
    orgaoJulgador: OrgaoJulgador = undefined;
    orgaoJulgadorColegiado: OrgaoJulgador = undefined;
    orgaoJulgadorCargo: OrgaoJulgadorCargo = undefined;
    dataAutuacao: Date = undefined;
    assuntos: IAssunto[] = [];

    partes: Partes;
    mensagemErroPartes?: string;
    alertas: AlertaDto[] = [];
    tarefaFluxo: TarefasFluxo = undefined;
    indicadores: Indicador[] = [];

    origem: string = '';

    impedimentos: string[] = [];
    sigUnAdm: string = undefined;
    
    get identificadorProcesso() {
        return this.idProcesso;
    }
}
